export const dpData = [
    {
        dictField: 'DESC_DOCUMENT',
        label: '说明文档'
    },
    {
        dictField: 'DATA_DOWNLOAD',
        label: '资料下载'
    }
];
